<template>
  <div class="worker">
    <div class="img"></div>
    <div class="contact">
      <h3>
        <i class="icon"></i>
        {{$t('title.w14')}}
      </h3>
      <div class="link">
        <!-- <a
          href="http://wpa.qq.com/msgrd?v=3&uin=997774555&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">997774555</p>
          <p>Gavin</p>
        </a>
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=997774515&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">997774515</p>
          <p>John</p>
        </a>-->
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=997774929&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">997774929</p>
          <p>Cici</p>
        </a>
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=997774989&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">997774989</p>
          <p>Tin</p>
        </a>
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=862188882&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">862188882</p>
          <p>Alina</p>
        </a>
        <!-- <a
          href="http://wpa.qq.com/msgrd?v=3&uin=1536926666&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">1536926666</p>
          <p>Arvin</p>
        </a>
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=1362386666&site=rzj.com&menu=yes"
          target="_blank"
          class="text"
        >
          <p class="p1">1362386666</p>
          <p>Toto</p>
        </a>-->
      </div>
    </div>
    <div class="contact">
      <h3>
        <i class="icon tel"></i>
        {{$t('title.w15')}}
      </h3>
      <div class="link">
        <div class="text bg-none">
          <p class="p1">（+86）400-886-3306</p>
          <p>{{$t('other.w33')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="less" scoped>
.worker {
  width: 400px;
  height: 100%;
  position: relative;
  background: url("../../assets/assetcenter/sidebar_bg4.png") no-repeat;
  background-size: 242px 162px;
  background-position: right bottom;
  .img {
    height: 239px;
    width: 400px;
    // margin-bottom: 40px;
    background: url("../../assets/assetcenter/sidebar_bg3.png") no-repeat;
    background-size: cover;
  }
  .contact {
    padding-left: 27px;
    z-index: 10;
    h3 {
      font-size: 18px;
      margin-bottom: 21px;
      .icon {
        display: inline-block;
        width: 44px;
        height: 44px;
        background: url("../../assets/assetcenter/sidebar_qq.png") no-repeat;
        background-size: cover;
        margin-right: 21px;
        vertical-align: middle;
      }
      .tel {
        background: url("../../assets/assetcenter/sidebar_qq copy@2x.png")
          no-repeat;
        background-size: cover;
      }
    }
    .link {
      margin-left: 65px;
      .text {
        display: inline-block;
        margin-bottom: 30px;
        width: 240px;
        height: 40px;
        font-weight: 500;
        color: #7b7b7b;
        background: url("../../assets/pubilc_more.png") no-repeat;
        background-size: 10px 22px;
        background-position: right center;
        .p1 {
          font-size: 24px;
          color: #232325;
          font-family: DIN-Medium;
        }
      }
      .bg-none {
        background: none;
      }
    }
  }
}
</style>
